import { render, staticRenderFns } from "./DerivacionesPage.vue?vue&type=template&id=1c03d5dc"
import script from "./DerivacionesPage.vue?vue&type=script&lang=js"
export * from "./DerivacionesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports